requirejs([
	'jquery',
	'jquery-ui',
	'addClearfix',
	'handlebars',
	'searchJSON',
	'topNavigation',
	'searchExpander',
	'jquery.1508.injectElem',
	'ScrollSpy',
	'page-list-navigation',
	'moment',
	'jquery.1508.appendItem',
	'jquery.1508.mobileNav',
	'jquery.1508.changeBackground',
	'jquery.1508.imageBuilder',
	'pageListHack',
	'detectPrint',
	'toggleMoreOnBands',
	'frontpage-shout',
	'imagemap',
	'resource-hero-text',
	'signupModal',
	'frontpage2017',
	'date-formatter',
	'gaHandler',
    'masonryLayout',
    '../libs/lazysizes.min',
	'subscribePage',
	'newsletter',
	'contactForm',
	'addMindkeyRequired',
],
	function ($) {
		var onReady, onLoad, onResize, afterResize, timer;


        /* Hookups
        ----------------------------*/
		onReady = function () {
			$('.row-container').addClearfix();

			var templatePerson = '<div class="grid3"><img src="{{Thumbnail}}"> <div class="contact-info vcard"><p class="fn" >{{FirstName}} {{LastName}}</p><p class="title">{{Title}}</p><div class="hidden"><p class="org">Horten</p><p class="tel"><span class="type">Direkte: </span><a href="tel:+45 33343536" class="value">+45 33343536</a></p><p class="tel"><span class="type">Mobil:	</span><a href="tel:+45 80802323">+45 80802323</a></p><p class="email"><span class="type">E-mail: </span><a href="mailto:app@horten.dk;" class="value">app@horten.dk</a></p></div></div><div class="links"><div class="spot-link"><a href="{{Url}}">KONTAKT</a></div></div></div>';
			var templateResource = '<div class="grid-3"><div class="reference-type"><span>{{type}}</span></div><div class="contact-info"><a href="/"><p class="title">En titel</p><p class="date">Dato</p><p class="authors">{{author}}</p></a><ul><li><a href="/">{{speciale}}</a></li></ul></div></div>';
			var templateCase = '<div class="grid-3"><img src="{{Thumbnail}}" /><div class="contact-info"><a href="{{Link}}"><p class="title">{{Title}}</p><p>{{Description}}</p></a></div</div>';
			
		
			if ($(".search-result-persons").length > 0) {
				$(".search-result-persons").SearchResult($(".search-filter"), {
					datapath: '/api/Persons',
					template: templatePerson,
					noResultHtml: $(".search-noresults").clone()
				});

				//TODO on load, change stilling to partner in dropdownlist
				//var selectBox = $("select[name=CategoryName]");
				//if (selectBox) {
				//	selectBox.select("Partnere");
                //}
			}

			if ($(".search-result-cases").length > 0) {
				$(".search-result-cases").SearchResult($(".search-filter"), {
					datapath: '/api/Cases',
					template: templateCase,
					noResultHtml: $(".search-noresults").clone()
				});
			}

			// if ($(".search-result-resources").length > 0) {
			// 	$(".search-result-resources").SearchResult($(".search-filter"), {
			// 		datapath: '/api/Resources',
			// 		template: $('.template').html(),
			// 		noResultHtml: $(".search-noresults").clone()
			// 	});
			// }

            if ($(".search-result-resources-sidebar").length > 0) {
                $(".search-result-resources-sidebar").SearchResult($(".search-filter"), {
                    datapath: '/api/ResourcesSidebar',
                    template: "#template"
                });
            }

			if ($(".search-result-persons-test").length > 0) {
				$(".search-result-persons-test").SearchResult($(".search-filter"), {
					datapath: '/resources/temp/contact.json',
					template: $('.template').html()
				});
			}

			if ($(".search-result-resources-test").length > 0) {
				$(".search-result-resources-test").SearchResult($(".search-filter"), {
					datapath: '/resources/temp/resources.json',
					template: "#template"
				});
			}

			$('.filter-container a[name!=""]').click(function (e) {
				e.preventDefault();
				$('input[type=checkbox][name!=' + $(this).attr('name') + ']').closest("div").hide("fast");
				$('input[type=checkbox][name=' + $(this).attr('name') + ']').closest("div").slideToggle("fast");
			});

			//Mobile menu slideup/down
			$('.main-navigation2').mobileNav({
				container: '.main',
				button: '[data-mobiletoggler]'
			});

			$(".global-search").focus(function () {
				$(this).keypress(function (e) {
					if (e.keyCode === 13) {
						$(".root-form").submit();
					}
				});
			});

			if (!Modernizr.input.placeholder) {
				$('[placeholder]').focus(function () {
					var input = $(this);
					if (input.val() === input.attr('placeholder')) {
						input.val('');
						input.removeClass('placeholder');
					}
				}).blur(function () {
					var input = $(this);
					if (input.val() === '' || input.val() === input.attr('placeholder')) {
						input.addClass('placeholder');
						input.val(input.attr('placeholder'));
					}
				}).blur();
				$('[placeholder]').parents('form').submit(function () {
					$(this).find('[placeholder]').each(function () {
						var input = $(this);
						if (input.val() === input.attr('placeholder')) {
							input.val('');
						}
					});
				});
			}


			//ImageBuilder - Url - Background
			$('[data-url]').imageBuilder({
				mobileUrl: '[data-mobileurl]',
				tabletUrl: '[data-tableturl]',
                url: '[data-url]',
				mobileSrc: '[data-mobilsrc]',
				mq: 568,
                mqTablet: 1024,
				imgWidth: '100%'
			});

			//ImageBuilder - Src - Img Tag
			$('[data-src]').imageBuilder({
				mobileUrl: '[data-mobilurl]',
				mobileSrc: '[data-mobilsrc]',
				mq: 568,
				imgWidth: '100%'
			});

			//Wrap all spotlink content with span (firefox fix)
			$('.spot-link a').injectElem({
				elem: '<span />'
			});

			$(document).bind("searchJSON_done", function () {
			});

			// Slideshare - hack slideshare component

			var $rh_link = $('.resource-hero .content-container a[target=_blank]');
			var $rh_img = $('.resource-hero .image-container img');

			if ($rh_link.length > 0 && $rh_img.length > 0) {
				var newlink = $rh_link.clone();
				$rh_img.wrap(newlink);
			}

			$(document).on('click', '[data-close]', function (e) {
				e.preventDefault();
				$('.cookie-control').toggle();
			});

			$("[data-panelToggle]").toggleBand();


			if ($('.wide-bg-container').outerWidth() > 1700) {
				$('.wide-bg-container').css('min-height', $('.wide-bg-container').outerWidth() * 0.4);
			}
			else if ($('.wide-bg-container').outerWidth() > 768) {
				$('.wide-bg-container').css('min-height', '620px');
			}
			else {
				$('.wide-bg-container').css('min-height', '0');
			}

			/* Map
			------------------------------------*/
			$('img[usemap]').rwdImageMaps();


			// Toggle linkedin click event
			$(document).on('click', '.linkedInToggle', function () {
				$('.IN-widget a').parent().click();
			});


			//Toggle contact information on signup page
			var rightAndInsightsCheckBox = $('[data-printed="true"]').find("> input[type='checkbox']");

			rightAndInsightsCheckBox.on("click", function () {
				if (rightAndInsightsCheckBox.is(":checked")) {
					$(".print-container").removeClass("hidden");
				} else {
					$(".print-container").addClass("hidden !important");
				}
			});

            lazySizesConfig.throttleDelay = 100;
            lazySizes.init();
            
            //Change linkedin button tag to an a tag to avoid page form wrapper conflict
			(function() {
				const linkedInElement = document.querySelector(".linkedIn");

				if (!linkedInElement) {
					return;
				}
				
				const changeLinkedinBtnToLink = function(mutationsList, observer) {
					for (let i = 0; i < mutationsList.length ; i++) {
						const mutation = mutationsList[i]

						if (mutation.type === "childList") {
							const linkedinBtn = document.querySelector(".IN-widget button");

							if (!linkedinBtn) {
								return;
							}

							const aTag = document.createElement("a");
							aTag.classList.add(linkedinBtn.className);
							aTag.innerHTML = linkedinBtn.innerHTML;

							linkedinBtn.parentNode.replaceChild(aTag, linkedinBtn);
						}
					}
				};

				const observer = new MutationObserver(changeLinkedinBtnToLink);
				observer.observe(linkedInElement, { attributes: false, childList: true, subtree: true });
			})();
		};

		// Trigger Click on Sign Up Modal
		var user = getSessionCookie("username");
		var visit = GetCookie("visit");

		window.addEventListener('CookieInformationConsentGiven', function (event) {
			if (CookieInformation.getConsentGivenFor('cookie_cat_functional')) {
				(function () { 
					if (user == "popup" && visit > 16) {
					} else {
						triggerClickCookie();
						user = "popup";
						if (user != "" && user != null) {
							if (window.location.hostname.indexOf("en.") == 0) {
							} else {
								setSessionCookie("username", user);
							}
						}
					}
				})();
			}
		}, false); 

		// Trigger Click
		function triggerClickCookie() {
			var expdate = new Date();
			var visit;
			expdate.setTime(expdate.getTime() + (24 * 60 * 60 * 1000 * 365));
			if (!(visit = GetCookie("visit")))
				visit = 0;
			visit++;

			if (window.location.hostname.indexOf("en.") == 0) {
			} else {
				SetCookie("visit", visit, expdate, "/", null, false);
				if (visit == 1 || visit == 5 || visit == 10 || visit == 15) {
					setTimeout(triggerClick, 2000);

					function triggerClick() {
						$(".signup-modal").trigger("click");
					}
				}
			}
		}

		// Set Session Cookie

		function setSessionCookie(cname, cvalue) {
			document.cookie = cname + "=" + cvalue + "; ";
		}

		function getSessionCookie(cname) {
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1);
				if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
			}
			return "";
		}

		// Set Cookie

		function getCookieVal(offset) {
			var endstr = document.cookie.indexOf(";", offset);
			if (endstr == -1)
				endstr = document.cookie.length;
			return decodeURI(document.cookie.substring(offset, endstr));
		}

		function GetCookie(name) {
			var arg = name + "=";
			var alen = arg.length;
			var clen = document.cookie.length;
			var i = 0;
			while (i < clen) {
				var j = i + alen;
				if (document.cookie.substring(i, j) == arg)
					return getCookieVal(j);
				i = document.cookie.indexOf(" ", i) + 1;
				if (i == 0)
					break;
			}
			return null;
		}

		function SetCookie(name, value) {
			var argv = SetCookie.arguments;
			var argc = SetCookie.arguments.length;
			var expires = (2 < argc) ? argv[2] : null;
			var path = (3 < argc) ? argv[3] : null;
			var domain = (4 < argc) ? argv[4] : null;
			var secure = (5 < argc) ? argv[5] : false;
			document.cookie = name + "=" + decodeURI(value) +
				((expires == null) ? "" : ("; expires=" + expires.toGMTString())) +
				((path == null) ? "" : ("; path=" + path)) +
				((domain == null) ? "" : ("; domain=" + domain)) +
				((secure == true) ? "; secure" : "");
		}


		onLoad = function () {
		};

		onResize = function () {
		};

		afterResize = function () {
			if ($('.wide-bg-container').outerWidth() > 1700) {
				$('.wide-bg-container').css('min-height', $('.wide-bg-container').outerWidth() * 0.4);
			}
			else if ($('.wide-bg-container').outerWidth() > 768) {
				$('.wide-bg-container').css('min-height', '620px');
			}
			else {
				$('.wide-bg-container').css('min-height', '0');
			}
		};


		/* Attach events
	  ----------------------------*/
		$(onReady);//Document ready
		$(window).load(onLoad); //Window load
		$(window).resize(function () {
			onResize();
			clearTimeout(timer);
			timer = setTimeout(afterResize, 50);
		});

	}
);

Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
    return (arg1 === arg2) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifnotEquals', function (arg1, arg2, options) {
    return (arg1 !== arg2) ? options.fn(this) : options.inverse(this);
});
Handlebars.registerHelper('toLowerCase', function (str) {
    return str.toLowerCase();
});

define("main", function(){});

